import { push } from 'react-router-redux'
import {
	ACTIONS,
	PATH_HOME,
	RECEIVE_MODAL_ACTIONS,
	RECEIVE_MODAL_LOGIN_STATE,
	RECEIVE_USER_INFORMATIONS,
	RECEIVE_USER_ROLES,
	SET_BACKPATH,
	TITLE,
	TOASTR_RESET
} from '../constants/HomeConstants'
import fetch from 'isomorphic-fetch'
import { checkAuth, getJson } from '../../utils/ActionUtils'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import SelectionAction from '../../dashboard/actions/SelectionAction'
import SiteAction from '../../sites/actions/SitesAction'
import DetailStationAction from '../../station/actions/DetailStationAction'
import ApplicationConf from '../../conf/ApplicationConf'
import CreditAction from './CreditAction'
import i18n from 'simple-react-i18n'
import ToastrAction from './ToastrAction'
import { ERROR, SUCCESS } from '../constants/ToastrConstants'

const HomeAction = {
	resetToastr: function () {
		return {
			type: TOASTR_RESET
		}
	},
	setTitle(title) {
		return { type: TITLE, title: title }
	},
	errorOnFetch: function (content) {
		return {
			type: ERROR,
			message: content
		}
	},
	doneOnFetch: function (content) {
		return {
			type: SUCCESS,
			message: content
		}
	},
	receiveUser: function (content, type) {
		return {
			type: type,
			user: content
		}
	},
	setBackPath: function (backPath) {
		return {
			type: SET_BACKPATH,
			backPath: backPath
		}
	},
	updateFirstConnection(login) {
		return dispatch => {
			return fetch(ApplicationConf.user.updateFirstConnection(), {
				method: 'POST',
				headers: { Authorization: btoa('Basic ' + login) }
			})
				.then(checkAuth)
				.then(() => {
					dispatch(HomeAction.fetchUser(login))
				}).catch(err => {
					dispatch(HomeAction.errorOnFetch(i18n.error.cannotSaveInformation + err))
				})
		}
	},
	fetchUser: function (login) {
		return function (dispatch) {
			return fetch(ApplicationConf.login.login(), {
				method: 'GET',
				headers: { Authorization: 'Basic ' + btoa(login) }
			})
				.then(checkAuth)
				.then(getJson)
				.then((json = []) => {
					dispatch(HomeAction.receiveUser(json, RECEIVE_USER_INFORMATIONS))
					return json
				}).then((jsonResult) => {
					if (jsonResult) {
						dispatch(HomeAction.fetchRoles(jsonResult.login))
					}
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err))
				})
		}
	},
	receiveRoles: function (roles) {
		return {
			roles: roles,
			type: RECEIVE_USER_ROLES
		}
	},

	fetchRoles: function (login) {
		return function (dispatch) {
			return fetch(ApplicationConf.user.getRoles(login), {
				method: 'GET',
				headers: { Authorization: 'AQUADB_BE' + btoa(login) }
			})
				.then(checkAuth)
				.then(getJson)
				.then((json = []) => {
					dispatch(HomeAction.receiveRoles(json))
				})
		}
	},

	logout() {
		return (dispatch) => {
			sessionStorage.removeItem('TOKEN')
			dispatch(AdministrationAction.resetAdministrationStore())
			dispatch(SelectionAction.resetSelection())
			dispatch(SiteAction.reset())
			dispatch(DetailStationAction.reset())
			dispatch(CreditAction.reset())
			dispatch(push(PATH_HOME))
			dispatch(HomeAction.setTitle(undefined))
			dispatch(ToastrAction.success(i18n.loginOutSuccess))
		}
	},
	updateLoginModalState: function (loginModalState) {
		return {
			loginModalState: loginModalState,
			type: RECEIVE_MODAL_LOGIN_STATE
		}
	},
	updateLoginModalActions: function (modalActions) {
		return {
			modalActions: modalActions,
			type: RECEIVE_MODAL_ACTIONS
		}
	},
	setAction(actions) {
		return { type: ACTIONS, actions: actions }
	}
}

export default HomeAction



// WEBPACK FOOTER //
// ./src/home/actions/HomeAction.js